var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-result__text" }, [
    _c(
      "a",
      {
        staticClass: "text--link",
        attrs: { href: _vm.result.href },
        on: { click: _vm.openLink },
      },
      [
        _c("h3", {
          staticClass: "text--title",
          domProps: { innerHTML: _vm._s(_vm.highlightedTitle) },
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "text--abstract",
          domProps: { innerHTML: _vm._s(_vm.highlightedAbstract) },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }